import React, { useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import {
  GetAuxiliaryServiceRequestById,
  GetSingleEmployeeMedicalRequisition,
} from "../../../../../utils/redux/HR/HRSlice";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import Table from "../../../Components/Table/Table";
import { TableActionsDownload } from "../../../Components/Misc/ActionsModVersion";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";

function ViewAuxiliaryRequest() {
  const navigate = useNavigate();
  const formMethods = useForm({
    mode: "all",
  });
  const { handleSubmit } = formMethods;
  const { id } = useParams();

  const submit = (e) => {
    alert("clicked");
  };
  const dispatch = useDispatch();
  const getRequest = useSelector((state) => state?.hr);
  const { auxiliary_service_request_by_id, isLoading } = getRequest;
  const request = auxiliary_service_request_by_id?.result;

  useEffect(() => {
    if (id) {
      dispatch(GetAuxiliaryServiceRequestById(id)); // Make sure 'id' is used here
    }
  }, [id, dispatch]);

  // Conditional loading state
  if (isLoading) {
    return (
      <PageLayout title={"Auxiliary Request Details"} hasBack={true}>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>Loading data, please wait...</p>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title={"Auxiliary Request Details"} hasBack={true}>
      <FormProvider {...formMethods}>
        <FormTemplate
          className={DashboardStyle.view_app_components}
          handleSubmit={handleSubmit(submit)}
        >
          {/* Request Details Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Request Details
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Initiated By:</p>
                  <h4>{request?.createdBy ?? "N/A"}</h4>{" "}
                </div>
                <div>
                  <p>Service Type:</p>
                  <h4>
                    {request?.auxiliaryServiceTypeId === 1
                      ? "CWAY"
                      : request?.auxiliaryServiceTypeId === 2
                      ? "Insurance Premium"
                      : "N/A"}
                  </h4>{" "}
                </div>
                <div>
                  <p>Date Requested:</p>
                  <h4>
                    {request?.createdDate
                      ? FormatDateTime(request?.createdDate, "ll")
                      : "N/A"}
                  </h4>{" "}
                </div>
              </div>
              <div>
                <div>
                  <p>Process Status:</p>
                  <h4
                    style={{
                      color:
                        request?.approvalStatus === 1
                          ? "#0F6308"
                          : request?.approvalStatus === 0
                          ? "#815103"
                          : request?.approvalStatus === 7
                          ? "#8A002B"
                          : "",
                    }}
                  >
                    {request?.approvalStatus === 1
                      ? "Initiated"
                      : request?.approvalStatus === 0
                      ? "Approved"
                      : request?.approvalStatus === 7
                      ? "Declined"
                      : "N/A"}
                  </h4>{" "}
                </div>
                <div>
                  <p>Number Of Bottles:</p>
                  <h4>{request?.numberOfBottles ?? "N/A"}</h4>{" "}
                </div>
              </div>
            </div>
          </section>

          {/* Asset Details Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>Asset Details</h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Asset Name:</p>
                  <h4>{request?.assetName ?? "N/A"}</h4>{" "}
                </div>
                <div>
                  <p>Serial Number:</p>
                  <h4>{request?.serialNumber ?? "N/A"}</h4>{" "}
                </div>
                <div>
                  <p>Registration Number:</p>
                  <h4>{request?.registrationNumber ?? "N/A"}</h4>{" "}
                </div>
              </div>
              <div>
                <div>
                  <p>Date Bought:</p>
                  <h4>
                    {request?.dateBought
                      ? FormatDateTime(request?.dateBought, "ll")
                      : "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Cost of Asset:</p>
                  <h4>
                    {request?.costOfAsset != null
                      ? FormatCurrency(request?.costOfAsset)
                      : "N/A"}
                  </h4>
                </div>
              </div>
            </div>
          </section>

          {/* Insurance Details Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Insurance Details
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Insured Amount:</p>
                  <h4>
                    {request?.insuredAmount != null
                      ? FormatCurrency(request?.insuredAmount)
                      : "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Mode of Payment:</p>
                  <h4>
                    {request?.paymentMode === 0
                      ? "One Off"
                      : request?.paymentMode === 1
                      ? "Salary Deduction"
                      : request?.paymentMode === 2
                      ? "Part Payment"
                      : "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Balance:</p>
                  <h4>
                    {request?.balance != null
                      ? FormatCurrency(request?.balance)
                      : "N/A"}
                  </h4>{" "}
                </div>
              </div>
              <div>
                <div>
                  <p>Deductible Amount:</p>
                  <h4>
                    {request?.deductibleAmount != null
                      ? FormatCurrency(request?.deductibleAmount)
                      : "N/A"}
                  </h4>{" "}
                </div>
                <div>
                  <p>Period of Deduction:</p>
                  <h4>
                    {request?.periodOfDeduction != null
                      ? `${request?.periodOfDeduction} months`
                      : "N/A"}
                  </h4>{" "}
                </div>
                <div>
                  <p>Deductible Once:</p>
                  <h4>
                    {request?.isDeductibleOnce === true ? "True" : "False"}
                  </h4>
                </div>
              </div>
            </div>
          </section>

          {/* Documents Uploads Section */}
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Documents <br /> Uploads
            </h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              {request?.documents?.[0] === "Documents Not Found" ? (
                <p>No Record Available</p>
              ) : (
                <Table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>File Name</th>
                      <th>File Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {request?.documents?.map?.((x, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{x?.file?.name || x?.fileName || "N/A"}</td>
                          <td style={{ textTransform: "uppercase" }}>
                            {x?.value || x?.fileName || "N/A"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </div>
          </section>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}


export default ViewAuxiliaryRequest;
